import { MouseEvent, useState } from "react";
import FileCopyRoundedIcon from "@material-ui/icons/FileCopyRounded";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

export const CopyContentIdButton = ({ contentId }: { contentId?: string }) => {
  const [isShowSnackbar, setIsShowSnackbar] = useState(false);

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (contentId) {
      navigator.clipboard
        .writeText(contentId)
        .then(() => {
          setIsShowSnackbar(true);
        })
        .catch((err) => {
          console.error("Failed to copy Content ID:", err);
        });
    }
  };

  return (
    <>
      <Snackbar
        open={isShowSnackbar}
        onClose={() => setIsShowSnackbar(false)}
        autoHideDuration={6000}
        transitionDuration={300}
      >
        <Alert severity="success">copied: ${contentId}</Alert>
      </Snackbar>
      <button
        type="button"
        disabled={!contentId}
        style={{ border: 0, background: "transparent", cursor: "pointer" }}
        onClick={handleClick}
      >
        <FileCopyRoundedIcon style={{ fontSize: "18px" }} />
      </button>
    </>
  );
};
